export default __webpack_public_path__ + "static/media/logodark.387c2a78.svg";